/*
|--------------------------------------------------------------------------
| Views: 101Things
|--------------------------------------------------------------------------
*/ 

/**
 * 101Things
 * @namespace
 */
__gh__webApp.views["101Things"] = {
	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		__gh__webApp.utilities.infiniteScroll.init();

	},


	"prepItemData": function(items){
		items 					= __gh__webApp.utilities.infiniteScroll.injectAds(items);
		return items;
	},


	"getSubView": function(bucket){
		// Prep Items
		bucket.items.main				= this.prepItemData(bucket.items.main);
		bucket.view.name 				= "buckets/101Things/default";
		bucket.view.infiniteScroll.view	= "buckets/101Things/partials/_default";
		return bucket;

	}
};
